var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_31363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 15.25,
    height: 11.252,
    rx: 1.625,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11L7.34507 5.06761C7.72093 4.74186 8.27907 4.74186 8.65493 5.06761L15.5 11",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 7.9333L0.71241 1.19589C0.609737 1.10096 0.633671 0.932676 0.758736 0.870144L1.5 0.499512H14.5L15.2413 0.870144C15.3663 0.932676 15.3903 1.10096 15.2876 1.19588L8.00002 7.9333Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.533203 1.1333L7.3011 7.29692C7.69323 7.65404 8.29597 7.6429 8.67464 7.27152L14.9332 1.1333",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 15.25,
    height: 11.252,
    rx: 1.625,
    stroke: "black",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_31363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49cd104cc006f9b3533b5ecd36d6b8c3.svg";
export { ForwardRef as ReactComponent };